import './TalkingLogo.css';

export interface TalkingLogoProps {
  /** When true, a speaking aura pulses around the logo. */
  speaking: boolean;
  /** Rendered square size in px (width and height). Default 220. */
  size?: number;
}

/**
 * Brand mark rendered as inline SVG. The mouth is static; while `speaking`
 * is true a radial glow + concentric rings pulse around the logo (behind it).
 * The artwork mirrors voice/src/assets/logo.svg. Skill-agnostic.
 */
export function TalkingLogo({ speaking, size = 220 }: TalkingLogoProps) {
  return (
    <div
      className={speaking ? 'talkingLogo-wrap speaking' : 'talkingLogo-wrap'}
      style={{ width: size, height: size }}
    >
      {/* speaking aura — sits BEHIND the logo, purely decorative */}
      <span className="talkingLogo-aura" aria-hidden="true">
        <span className="talkingLogo-glow" />
        <span className="talkingLogo-ring talkingLogo-ring-1" />
        <span className="talkingLogo-ring talkingLogo-ring-2" />
        <span className="talkingLogo-ring talkingLogo-ring-3" />
      </span>

      <svg
        className="talkingLogo-svg"
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Assistant"
      >
        <defs>
          <linearGradient id="talkingLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#67E8F9" />
            <stop offset="100%" stopColor="#0891B2" />
          </linearGradient>
        </defs>

        {/* face panel */}
        <rect x="22" y="30" width="56" height="46" rx="13" fill="url(#talkingLogoGrad)" />
        {/* left eye */}
        <rect x="39" y="44" width="6.5" height="14" rx="2" fill="#fff" />
        {/* right eye */}
        <circle cx="58" cy="51" r="7" fill="#fff" />

        {/* mouth (static) */}
        <g className="talkingLogo-mouth">
          <rect x="34" y="64" width="32" height="5" rx="2.5" fill="#fff" opacity="0.55" />
          <rect x="34" y="64" width="18" height="5" rx="2.5" fill="#0E7490" />
        </g>

        {/* antenna */}
        <line x1="50" y1="30" x2="50" y2="19" stroke="#22D3EE" strokeWidth="5" strokeLinecap="round" />
        <circle cx="50" cy="15" r="4.5" fill="#22D3EE" />
        {/* sparkle */}
        <path
          d="M80 18 C81 23 83.5 25.5 88 26 C83.5 26.5 81 29 80 34 C79 29 76.5 26.5 72 26 C76.5 25.5 79 23 80 18 Z"
          fill="#A78BFA"
        />
      </svg>
    </div>
  );
}

export default TalkingLogo;
